/**
 * Generate URL-safe slug from text (must match backend generate_slug).
 * Used as fallback when slug field isn't available in the data.
 */
export function toSlug(text) {
  if (!text) return 'unknown';
  return text.toLowerCase().trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'untitled';
}

/** Build artist profile URL */
export function artistUrl(artist) {
  const slug = artist?.slug || toSlug(artist?.name);
  return `/artist/${slug}`;
}

/** Build album URL: /:artistSlug/album/:albumSlug */
export function albumUrl(album) {
  const aSlug = album?.artist_slug || toSlug(album?.artist_name);
  const slug = album?.slug || toSlug(album?.title);
  return `/${aSlug}/album/${slug}`;
}

/** Build track URL: /:artistSlug/track/:trackSlug */
export function trackUrl(track) {
  const aSlug = track?.artist_slug || toSlug(track?.artist_name);
  const slug = track?.slug || toSlug(track?.title);
  return `/${aSlug}/track/${slug}`;
}

/** Build single URL: /:artistSlug/single/:singleSlug */
export function singleUrl(track) {
  const aSlug = track?.artist_slug || toSlug(track?.artist_name);
  const slug = track?.slug || toSlug(track?.title);
  return `/${aSlug}/single/${slug}`;
}
